import { css } from "@emotion/css";
import { CircularProgress, LegacyCard } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { WelcomeDialogSignIcon } from "../WelcomeDialogSignIcon";
import type { WelcomeDialogCardProps } from "./WelcomeDialogCardProps";
import { cardStyles } from "./styles";
export function SampleProjectCard({ busy, onClick }: WelcomeDialogCardProps) {
    const LoadingContent = () => {
        return (<div className={loadingStyles}>
                <CircularProgress size="small"/>
                <div>Loading sample project</div>
            </div>);
    };
    return (<LegacyCard link={!busy && (<a href="#" onClick={onClick} className={cardStyles.link}>
                        Create sample project
                    </a>)} logo={<div className={cardStyles.logo(!busy)}>
                    <WelcomeDialogSignIcon />
                </div>} header={<div className={cardStyles.header}>Sample project</div>} content={busy ? <LoadingContent /> : "Learn the basics with a fully editable sample project."} className={cardStyles.card} contentClassName={cardStyles.content} leftAlign={true}/>);
}
const loadingStyles = css({
    display: "flex",
    alignItems: "center",
    gap: space[12],
    height: "100%",
    paddingTop: space[12],
    paddingBottom: space[12],
});
